import React from "react";
import IconButton from "@mui/material/IconButton";
import LogoHori from "../../../../../assets/Images/Logo/LogoHori";
import {Link} from "react-router-dom";


export const BtnLogoHori = ({widthPx}) => {
    return (
    <IconButton component={Link} to='/' variant="contained" color="primary">
        <LogoHori widthPx={widthPx}/>
    </IconButton>
    )
}
